import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled, { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { ReactComponent as ChevronDownIcon } from "feather-icons/dist/icons/chevron-down.svg";

const PrimaryBackgroundContainer = tw(Container)`-mx-8 px-8 bg-primary-900 text-gray-100`;

const HeadingContainer = tw.div``;
const Subheading = tw(SubheadingBase)`text-center text-gray-100 mb-4`;
const Heading = tw(SectionHeading)``;
const Description = tw(SectionDescription)`mx-auto text-center text-gray-300`;

const FaqsContainer = tw.div`mt-10 sm:mt-16 w-full flex-1 lg:flex justify-between items-start max-w-screen-lg mx-auto`;
const FaqsColumn = tw.div`w-full lg:max-w-lg lg:mr-12 last:mr-0`;
const Faq = tw.div`select-none cursor-pointer border-b-2 border-primary-300 hover:border-primary-500 transition-colors duration-300 py-6`;
const Question = tw.div`flex justify-between items-center`;
const QuestionText = tw.div`text-sm sm:text-lg font-semibold tracking-wide`;
const QuestionToggleIcon = styled(motion.span)`
  ${tw`ml-2 transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`;
const Answer = tw(motion.div)`hidden text-sm font-normal mt-4 text-gray-300`;

export default ({
  subheading = "",
  heading = "Frequently Asked Questions",
  description = "Beginner sessions? Main sessions? Here are answers to our most frequent questions.",
  faqs = [
    {
      question: "Is the club meeting now?",
      answer:
        "YES."
    },
    {
      question: "When and Where is the Main Session?",
      answer:
        "Aberystwyth Fencing Club meet in the sports hall at Penweddig School at 19:00 on Thursdays. Experienced fencers are welcome."
    },
    {
      question: "How much does the Main Session cost?",
      answer:
        "We charge £6 (concession is £5) per session."
    },
    {
      question: "What do I need to join the Main Session?",
      answer:
        "All fencers are required to be members of British Fencing as this provides you with individual insurance.  The club can provide all equipment EXCEPT breeches."
    },
    {
      question: "I've never fenced before.  Can I join?",
      answer:
        "Yes! We run 5-week Beginner Courses taught by our professional coaches to get you started in fencing. This course is for anyone over 13 years old of any ability. See the club calendar for upcoming courses and please e-mail the club for more information."
    },
    {
      question: "How much is a Beginner Course?",
      answer:
        "The fee for the entire 5-week course is £30 (concession is £25)."
    },
    {
      question: "What do I need for the Beginner Course?",
      answer: "Yourself. Tough loose fitting trousers/leggings such as jogging pants or jeans. Non-marking, flat soled training shoes. A drink. All safety equipment and weapons are provided!"
    },
    {
      question: "Will I get hurt?",
      answer:
        "Not if it's done properly! Fencing is about speed and accuracy, heavy hitting implies large slow counter-productive hand movements. Further, hitting hard is illegal as far as the rules are concerned and can disqualify you from competitions. Safety equipment is provided to prevent injury and if you use the weapons as instructed by your coach there should be no problem!"
    }
  ]
}) => {
  const faqCol1 = [];
  const faqCol2 = [];
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  const toggleQuestion = questionIndex => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
    else setActiveQuestionIndex(questionIndex);
  };

  faqs.map((faq, index) => {
    const renderedFaq = (
      <Faq key={index} onClick={() => toggleQuestion(index)}>
        <Question>
          <QuestionText>{faq.question}</QuestionText>
          <QuestionToggleIcon
            variants={{
              collapsed: { rotate: 0 },
              open: { rotate: -180 }
            }}
            initial="collapsed"
            animate={activeQuestionIndex === index ? "open" : "collapsed"}
            transition={{ duration: 0.02, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <ChevronDownIcon />
          </QuestionToggleIcon>
        </Question>
        <Answer
          variants={{
            open: { opacity: 1, height: "auto", marginTop: "16px", display: "block" },
            collapsed: { opacity: 0, height: 0, marginTop: "0px", display: "none" }
          }}
          initial="collapsed"
          animate={activeQuestionIndex === index ? "open" : "collapsed"}
          transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
        >
          {faq.answer}
        </Answer>
      </Faq>
    );

    if (index % 2 === 0) faqCol1.push(renderedFaq);
    else faqCol2.push(renderedFaq);

    return null;
  });
  return (
    <PrimaryBackgroundContainer>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          <Description>{description}</Description>
        </HeadingContainer>
        <FaqsContainer>
          <FaqsColumn>{faqCol1}</FaqsColumn>
          <FaqsColumn>{faqCol2}</FaqsColumn>
        </FaqsContainer>
      </ContentWithPaddingXl>
    </PrimaryBackgroundContainer>
  );
};
